define('ProductDetails.Component.GiftWrap', [
    'SC.Configuration',
    'ProductDetails.QuickView.View',
    'jQuery'
],
function ProductDetailsComponentGiftWrap(
    Configuration,
    ProductDetailsQuickViewView,
    jQuery
) {
    'use strict';

    var displayGiftWrapOption = function displayGiftWrapOption(pdpComponent) {
        var selectedChilds = pdpComponent.getSelectedMatrixChilds() || [];
        var itemInfo;
        var application = pdpComponent && pdpComponent.application;
        var layout = application && application.getLayout();
        var currentView = layout && layout.getCurrentView();
        var model = currentView && currentView.model;
        var fulfilmentChoice = model && model.get('fulfillmentChoice');

        // Canada only use GiftWrap for PickupInStore items
        if (Configuration.get('country') === 'CA') {
            if (Configuration.get('customizations.giftWrap.disableGiftwrap')) {
                jQuery('[data-view="Product.Options"] [data-cart-option-id="custcol_gift_wrap"]').remove();
            } else {
                jQuery('[data-view="Product.Options"] [data-cart-option-id="custcol_gift_wrap"]').hide();
            }
            return;
        }

        if (fulfilmentChoice === 'pickup') {
            jQuery('[data-view="Product.Options"] [data-cart-option-id="custcol_gift_wrap"]').hide();
            return;
        }

        // If this is a matrix item
        if (selectedChilds.length > 0) {
            itemInfo = pdpComponent.getItemInfo();
            // If the selected child is giftwrappable
            if (selectedChilds.length === 1 && selectedChilds[0][itemInfo.item.keyMapping_isGiftwrappable]) {
                jQuery('[data-cart-option-id="custcol_gift_wrap"]').show();
            } else {
                jQuery('[data-cart-option-id="custcol_gift_wrap"]').hide();
                jQuery('[name="custcol_gift_wrap"]').prop('checked', false);
            }
        }
    };

    return {
        mountToApp: function mountToApp(container) {
            var pdpComponent = container.getComponent('PDP');

            pdpComponent.on('afterShowContent', function afterShowContent() {
                displayGiftWrapOption(pdpComponent);
            });

            pdpComponent.on('afterOptionSelection', function afterOptionSelection() {
                displayGiftWrapOption(pdpComponent);
            });
        }
    };
});

